import {Component} from "@angular/core";
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {DateApplication} from "@domain/admin/frais/indemnites/frais-mission-detail";

/**
 * Composant d'affichage d'une date d'application dans la liste
 * */
@Component({
    host: {'data-test-id': 'date-application-list-item'},
    selector: 'date-application-list-item',
    templateUrl: './date-application-list-item.component.html',
    styleUrls: ['./date-application-list-item.component.scss']
})
export class DateApplicationListItemComponent extends ListViewItem<DateApplication> {

    /**
     * Clic sur édition
     */
    onEdit(): void {
        this.liste?.extraOptions?.onEdit?.(this.data);
    }

    /**
     * Clic sur suppression
     */
    onDelete(): void {
        this.liste?.extraOptions?.onDelete?.(this.data);
    }

    /**
     * Indique si on doit afficher un drapeau
     */
    hasDrapeau(): boolean {
        return !!(this.data?.fraisMissionRegion?.codeIso && (this.data.fraisMissionRegion.idPays || this.data.fraisMissionRegion.idVille));
    }
}